import $ from 'jquery';
import Widgets from 'js-widget-hooks';
import 'bootstrap/js/modal';

export default {

    /**
     *
     * @param mId
     * @returns {boolean}
     */
    open: function(mId) {
        const modal = $('#' + mId);

        if (modal.length) {
            modal.modal('show');
            Widgets.init(modal[0]);
            return modal;
        }

        return false;
    },

    /**
     *
     * @param template
     * @returns {*|jQuery}
     */
    create: function(template) {
        const modal = $(template).modal();
        Widgets.init(modal[0]);
        return modal;
    }

};